import { ColumnContent } from "@qw/ui";
import { useInboxInsured } from "../../providers/use-inbox-insured";
import { ActiveDraftQuotes } from "./active-draft-quotes";
import { ActiveOpportunities } from "./active-opportunities";
import { ActivePolicies } from "./active-policies";
import { ActiveQuotes } from "./active-quotes";

export const Active = ({
  liveUpdates = true,
  showOpportunitySubmissions = true,
}: {
  liveUpdates?: boolean;
  showOpportunitySubmissions?: boolean;
}) => {
  const { insured } = useInboxInsured();
  return (
    <ColumnContent>
      {insured && (
        <>
          <ActiveOpportunities liveUpdates={liveUpdates} showSubmissions={showOpportunitySubmissions} />
          <ActiveDraftQuotes />
          <ActiveQuotes />
          <ActivePolicies />
        </>
      )}
    </ColumnContent>
  );
};
